import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWrapper, ContinueButton } from './Button.styled';

const Continue = ({
  id,
  label,
  disabled,
  loading,
  className,
  children,
  onClickHandler,
  type = 'button',
}) => {
  return (
    <ButtonWrapper data-testid='continue'>
      <ContinueButton
        type={type}
        id={id}
        className={className}
        disabled={disabled}
        onClick={onClickHandler}
      >
        {children && children}
        {loading ? '' : label}
      </ContinueButton>
    </ButtonWrapper>
  );
};

Continue.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default Continue;
